<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormUser" role="form" method="post" autocomplete="off" onSubmit="return false">

					<div class="row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
							<div class="avatar-upload">
								<div class="avatar-edit">
									<input id="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview'))" ref="fileImg" type="file" name="file" accept=".png, .jpg, .jpeg">
									<label for="file"></label>
								</div>
								<div class="avatar-preview">
									<div id="imagePreview" :style="'background-image: url('+RutaFile+objUser.UrlImg+')'" :src="RutaFile+objUser.UrlImg">
									</div>
								</div>
							</div>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-8 col-xl-8">

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="ApellidoPat">Apellido Paterno</label>
									<input type="text" v-model="objUser.ApellidoPat" class="form-control" id="ApellidoPat" placeholder="Ingresar Apellido Paterno" />
									<CValidation v-if="this.errorvalidacion.ApellidoPat" :Mensaje="'*'+errorvalidacion.ApellidoPat[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="ApellidoMat">Apellido Materno</label>
									<input type="text" v-model="objUser.ApellidoMat" class="form-control" id="ApellidoMat" placeholder="Ingresar Apellido Materno" />
									<CValidation v-if="this.errorvalidacion.ApellidoMat" :Mensaje="'*'+errorvalidacion.ApellidoMat[0]"/>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="Nombre">Nombres</label>
									<input type="text" v-model="objUser.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombres" />
									<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="IdPerfil">Perfil</label>
									<select v-model="objUser.IdPerfil" name="item17" id="item17" class="form-control form-select">
										<option value="0">--Seleccionar--</option>
										<option :value="ListaPerfiles.IdPerfil" >{{ListaPerfiles.Nombre}}</option>
									</select>
									<CValidation v-if="this.errorvalidacion.IdPerfil" :Mensaje="'*'+errorvalidacion.IdPerfil[0]"/>
								</div>
							</div>
							
							<div class=" row">
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="IdDepartamento">Departamento</label>
									<select v-model="objUser.IdDepartamento" name="IdDepartamento" id="IdDepartamento" class="form-control form-select">
										<option value="0">--Seleccione una opción--</option>
										<option :value="ListaDepartamentos.IdDepartamento" >{{ListaDepartamentos.Nombre}}</option>
									</select>
									<CValidation v-if="this.errorvalidacion.IdDepartamento" :Mensaje="'*'+errorvalidacion.IdDepartamento[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="Correo">Correo</label>
									<input type="text" v-model="objUser.Correo" class="form-control" id="Correo" placeholder="Ingresar Correo" />
									<CValidation v-if="this.errorvalidacion.Correo" :Mensaje="'*'+errorvalidacion.Correo[0]"/>
								</div>
							</div>
							
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="Telefono">Teléfono</label>
							<input type="text" v-model="objUser.Telefono" class="form-control" id="Telefono" placeholder="Ingresar Teléfono" />
							<CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*'+errorvalidacion.Telefono[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="username">Usuario</label>
							<input type="text" v-model="objUser.username" class="form-control" id="username" placeholder="Ingresar Usuario" />
							<CValidation v-if="this.errorvalidacion.username" :Mensaje="'*'+errorvalidacion.username[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="password">Contraseña</label>
							<div class="input-icons">
								<input :type="Type" v-model="objUser.password" class="form-control" id="password" placeholder="Ingresar Contraseña" autocomplete="off" />
								<button v-if="objUser.password !== ''" @click="ToggleShow" class="button btn-password-form-rec" type="button" id="button-addon2">
									<i class="far icono-password" :class="{ 'fa-eye-slash': ShowPassword, 'fa-eye': !ShowPassword }"></i>
								</button>
							</div>
							<CValidation v-if="this.errorvalidacion.password" :Mensaje="'*'+errorvalidacion.password[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
							<label class="form-label" for="password">Confirmar Contraseña</label>
							<div class="input-icons">
								<input :type="Type2" v-model="objUser.passwordConfirm" class="form-control" id="password2" placeholder="Confirmar Contraseña" autocomplete="off" />
								<button v-if="objUser.passwordConfirm !== ''" @click="ToggleShow2" class="button btn-password-form-rec" type="button" id="button-addon3">
									<i class="far icono-password" :class="{ 'fa-eye-slash': ShowPassword2, 'fa-eye': !ShowPassword2 }"></i>
								</button>
							</div>
							<CValidation v-if="this.errorvalidacion.passwordConfirm" :Mensaje="'*'+errorvalidacion.passwordConfirm[0]"/>
						</div>
						
					</div>
				
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';

export default {
    name: 'FormUser',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objUser: {
				IdUsuario: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				IdPerfil: 0,
				IdDepartamento: 0,
				Nombre: '',
				ApellidoPat: '',
				ApellidoMat: '',
				NombreCompleto: '',
				Correo: '',
				Telefono: '',
				username: '',
				password: '',
				passwordConfirm: '',
				Imagen: '',
				Estatus: 'Activo',
				TipoUsuario: 'US',
				UrlImg: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			ValidElement: Configs.validImage2m,
			ListaPerfiles: {},
			ListaDepartamentos: {},
			RutaFile: '',
			Img: null,
			Type: 'password',
            ShowPassword: false,
			Type2: 'password',
            ShowPassword2: false,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
			formData.set('IdUsuario', this.objUser.IdUsuario);
			formData.set('IdPerfil', this.objUser.IdPerfil);
			formData.set('IdDepartamento', this.objUser.IdDepartamento);
			formData.set('Nombre', this.objUser.Nombre);
			formData.set('ApellidoPat', this.objUser.ApellidoPat);
			formData.set('ApellidoMat', this.objUser.ApellidoMat);
			formData.set('Correo', this.objUser.Correo);
			formData.set('Telefono', this.objUser.Telefono);
			formData.set('username', this.objUser.username);
			formData.set('password', this.objUser.password);
			formData.set('passwordConfirm', this.objUser.passwordConfirm);
			formData.set('Estatus', this.objUser.Estatus);
			formData.set('TipoUsuario', this.objUser.TipoUsuario);
			formData.set('IdEmpresa', this.objUser.IdEmpresa);
			formData.set('IdSucursal', this.objUser.IdSucursal);

			formData.set('ImagenAntigua', this.objUser.UrlImg);

			let Imagen = this.$refs.fileImg.files[0];
			formData.append('Imagen',Imagen);
			
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			
			await this.$http.post('sucursalUsuario', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "sucursalUsuario/"+this.objUser.IdSucursal
            ).then((res) => {
				this.RutaFile = res.data.RutaFile;
				this.ListaPerfiles = res.data.perfil;
				this.ListaDepartamentos = res.data.depart;

				if(res.data.existe == 1){
					this.objUser = res.data.data;
				}

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objUser = {
				IdUsuario: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				IdPerfil: 0,
				IdDepartamento: 0,
				Nombre: '',
				ApellidoPat: '',
				ApellidoMat: '',
				NombreCompleto: '',
				Correo: '',
				Telefono: '',
				username: '',
				password: '',
				passwordConfirm: '',
				Imagen: '',
				Estatus: 'Activo',
				TipoUsuario: 'US',
				UrlImg: '',
				
            }
            this.errorvalidacion = [];
        },
		GetListPerfiles()
		{
			this.$http.get('perfilesSimple', {
				params:{
					simple: 1,
					TipoPerfil: 'US',
				}
			}).then( (res) => {
				this.ListaPerfiles = res.data.data;
			});
		},
		GetListDepartamentos()
		{
			this.$http.get('departamentos', {
				params:{
					simple: 1,
				}
			}).then( (res) => {
				this.ListaDepartamentos = res.data.data;
			});
		},
		ToggleShow()
        {
            if (this.ShowPassword = !this.ShowPassword) {                    
                this.Type = 'text'
            } else {
                this.Type = 'password'
            }    
        },
		ToggleShow2()
        {
            if (this.ShowPassword2 = !this.ShowPassword2) {                    
                this.Type2 = 'text'
            } else {
                this.Type2 = 'password'
            }    
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			//this.GetListPerfiles();
			// this.GetListDepartamentos();

			this.objUser.IdSucursal = obj.IdSucursal;
			this.objUser.IdEmpresa = obj.IdEmpresa;
			this.Recuperar();
        });
    }
}
</script>
